import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom'
import { BbIcon } from '../../components/BbIcon'
import { BbStepper } from '../../components/BbStepper'
import { useModifyWizard } from '../../modify/ModifyWizardContext'
import { formatInt } from '../../lib/format'
import { MODIFY_STEPS } from './steps'

/* Step 4. The job is submitted by the edit step's Save button, which navigates
   here with { jobId }. Nothing calls the API on this screen — a submit in an
   effect double-fired under React StrictMode and queued two jobs per click on
   the Delete flow, so the only thing here is the acknowledgement. */
export function ModifyDonePage() {
  const wizard = useModifyWizard()
  const navigate = useNavigate()
  const { state } = useLocation()

  const { jobId, count } = (state as { jobId?: string; count?: number } | null) ?? {}

  if (!wizard.entityType) return <Navigate to="/app/modify" replace />

  const subject = wizard.entity?.label ?? wizard.entityType

  const startOver = () => {
    wizard.reset()
    navigate('/app/modify')
  }

  return (
    <div className="bb bb-wizard">
      <BbStepper steps={MODIFY_STEPS} current={4} />

      <div className="bb-panel-card">
        <div className="bb-panel-card-b">
          <div className="bb-success">
            <span className="bb-success-ico">
              <BbIcon name="check-circle" />
            </span>
            <h2>Modify Job Queued</h2>
            <p>
              Your changes to{' '}
              <b>
                {count ? `${formatInt(count)} ` : ''}
                {subject.toLowerCase()} record{count === 1 ? '' : 's'}
              </b>{' '}
              are queued. QuickBooks is updated one record at a time, so check the job page for
              which ones it accepted.
            </p>
          </div>
        </div>
      </div>

      <div className="bb-wizard-foot">
        <button className="bb-btn bb-btn-quiet" type="button" onClick={startOver}>
          Modify more records
        </button>
        <span className="bb-wizard-foot-r">
          <Link className="bb-btn bb-btn-navy" to={jobId ? `/app/jobs/${jobId}` : '/app/jobs'}>
            <BbIcon name="history" />
            {jobId ? 'View this job' : 'Go to Job History'}
          </Link>
        </span>
      </div>
    </div>
  )
}
